module.exports = __webpack_public_path__ + "media/applications/components/HeaderApp/assets/close-f4fb1c61018da6f0cba28179c29433cb.svg";